<div class="primus-menu-button-wrapper">
  @if (menuButtonLabel || !menuButtonIcon) {
    <button
      mat-stroked-button
      class="admin-stroked-button"
      type="button"
      [disabled]="disabled"
      [matMenuTriggerFor]="menu.menu"
    >
      @if (menuButtonIcon) {
        <mat-icon>
          {{ menuButtonIcon }}
        </mat-icon>
      }

      <span class="bold uppercase admin-stroked-button__left-margin">
        {{ menuButtonLabel | translate }}
      </span>
    </button>
  }
  @else if (menuButtonIcon && !menuButtonLabel) {
    <button
      mat-icon-button
      class="admin-stroked-button"
      type="button"
      [color]="color"
      [disabled]="disabled"
      [matMenuTriggerFor]="menu.menu"
    >
      <mat-icon>
        {{ menuButtonIcon }}
      </mat-icon>
    </button>
  }

  <app-primus-menu-button-item
    #menu
    [color]="color"
    [items]="menuItems"
    [selectionState]="selectionGroups"
    (menuItemClicked)="handleMenuItemClicked($event)"
  ></app-primus-menu-button-item>
</div>
